class utilitState {
  MSK_OFFSET_MS = 3 * 60 * 60 * 1000;

  // dd.mm.yyyy hh:mm:ss (MSK, UTC+3)
  parseModificationUtcMs = (date) => {
    if (date == null || date === "") return NaN;
    const s = String(date).trim();
    const hasTz = /[Zz]$|[+-]\d{2}:?\d{2}$/.test(s);
    const iso = hasTz ? s : `${s}Z`;
    return new Date(iso).getTime();
  };

  datetimeLocalToMs = (value) => {
    if (!value) return NaN;
    return new Date(String(value).replace(/ /g, "T")).getTime();
  };

  historyLabelToMs = (label) => {
    if (!label) return NaN;
    const parts = String(label).trim().split(" ");
    if (parts.length < 2) return NaN;
    const [day, month, year] = parts[0].split(".");
    const time = parts[1];
    if (!day || !month || !year || !time) return NaN;
    return Date.parse(
      `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}T${time}+03:00`,
    );
  };

  ddmmyyyyhhmm = (date) => {
    const utcMs = this.parseModificationUtcMs(date);
    if (Number.isNaN(utcMs)) return "";
    const mskMs = utcMs + this.MSK_OFFSET_MS;
    const _d = new Date(mskMs);

    return `${String(_d.getUTCDate()).padStart(2, "0")}.${String(
      _d.getUTCMonth() + 1,
    ).padStart(2, "0")}.${String(_d.getUTCFullYear())} ${String(
      _d.getUTCHours(),
    ).padStart(2, "0")}:${String(_d.getUTCMinutes()).padStart(2, "0")}:${String(
      _d.getUTCSeconds(),
    ).padStart(2, "0")}`;
  };
}
export default new utilitState();
